import Vue from "vue";
import Router from "vue-router";
import Portal from "./views/Portal.vue";

import axios from "axios";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "portal",
      component: Portal,
      redirect: "/top/",
      meta: {
        requireAuthn: true
      },
      children: [
        {
          path: "top/",
          name: "top",
          component: () =>
            import(/* webpackChunkName: "main" */ "./views/portal/Top.vue")
        },
        // {
        //   path: "top/admin/",
        //   name: "topadmin",
        // redirect: "/admin/",

        //   component: () =>
        //     import(/* webpackChunkName: "admin" */ "./views/portal/Admin.vue"),
        // },        
        {
          path: "admin/",
          name: "admin",
          component: () =>
            import(/* webpackChunkName: "admin" */ "./views/portal/Admin.vue"),
          children: [
            {
              path: "users/",
              name: "users",
              component: () =>
                import(/* webpackChunkName: "admin-users" */ "./views/portal/admin/Users.vue"),
              props: true
            },
            {
              path: "tenants/",
              name: "tenants",
              component: () =>
                import(/* webpackChunkName: "admin-tenants" */ "./views/portal/admin/Tenants.vue"),
              props: true
            },
            {
              path: "consumers/",
              name: "consumers",
              component: () =>
                import(/* webpackChunkName: "admin-consumers" */ "./views/portal/admin/Consumers.vue"),
              props: true
            },
            {
              path: "announce/",
              name: "announce",
              component: () =>
                import(/* webpackChunkName: "admin-consumers" */ "./views/portal/admin/Announces.vue"),
              props: true
            },
            {
              path: "manuals/",
              name: "manuals",
              component: () =>
                import(/* webpackChunkName: "admin-consumers" */ "./views/portal/admin/Manuals.vue"),
              props: true
            },
            {
              path: "departments/",
              name: "departments",
              component: () =>
                import(/* webpackChunkName: "admin-consumers" */ "./views/portal/admin/Departments.vue"),
              props: true
            },
          ]
        },
      ]
    },
    {
      path: "/login/",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/change-password/",
      name: "changePassword",
      component: () =>
        import(/* webpackChunkName: "changePassword" */ "./views/ChangePassword.vue")
    }
  ]
});

const handleError = function(error, cb) {
  if ("response" in error) {
    var code = error.response.status;
    if (code === 400 || code === 401) {
      // 未認証・認証切れ・不正な認証トークン
      store.dispatch("updateIsInternalMove", true);
      window.location.href =
        "/login/?next=" +
        encodeURIComponent(window.location.pathname + window.location.hash);
      const args = [];
      cb(args);
    } else if (code === 403) {
      // 強制パスワード変更
      store.dispatch("updateIsInternalMove", true);
      window.location.href = "/login/#/change-password";
    }
  } else {
    cb();
  }
};

// 認証・認可 確認
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuthn)) {
    axios
      .get("/api/accounts/verify/")
      .then(response => {
        if (to.matched.some(record => record.meta.requireAdmin)) {
          if (response.data.is_superuser) {
            next();
          } else {
            next(false);
          }
        } else {
          next();
        }
      })
      .catch(error => {
        handleError(error, next);
      });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  let el = document.getElementsByClassName("main");
  for (var i = 0; i < el.length; i++) {
    el.item(i).scroll(0, 0);
  }
});

export default router;
